// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const emailTemplateStatsSchema = z.object({
  url: urlSchema,
  manualCount: z.number(),
  automatedCount: z.number(),
});
